import '@ebay/cookies-browser';

export default class {
    onMount() {
        this.subscribeTo(document.body).on('click', (e) => {
            const element = e.target.closest('[data-track]');
            const trackingData = element && element.dataset && element.dataset.track;
            const trackingObj = trackingData ? JSON.parse(trackingData) : null;
            if (trackingObj) {
                document.dispatchEvent(new CustomEvent('pulsar', { detail: trackingObj }));
            }
        });
    }
}
